import React, { useEffect, useState } from "react";
import { NavBar, SideBar, Breadcrumb, UpdateContact } from "../components";
import { handleOnClickLogout, getAllCards, getContact } from "../constants";
import { useNavigate, useParams } from "react-router-dom";

const UpdatedContact = () => {
  const user = JSON.parse(localStorage.getItem("user_info"));
  const token = user.access_token;
  const navigate = useNavigate();
  const [initial, setInitial] = useState(false);
  const [contactData, setContactData] = useState({});
  const [cards, setCards] = useState([]);
  const { contactId } = useParams();
  const [loading, setLoading] = useState(false);
  const [breads, setBreads] = useState(["Contacts"]);
  const changeBreadCrumbs = (i) => {
    setBreads(breads.slice(0, i + 1));
  };
  useEffect(() => {
    if (breads.length < 2 && initial) {
      navigate("/contacts");
    }
  }, [breads]);

  useEffect(() => {
    if (Object.keys(contactData).length > 0) {
      if (breads.length == 1) {
        setBreads([
          ...breads,
          `${contactData.first_name} ${contactData.last_name}`,
        ]);
      }
    }
    setInitial(true);
  }, [contactData]);

  useEffect(() => {
    getContact(token, contactId, setContactData);
    getAllCards(token, setCards);
  }, []);

  return (
    <div className="flex flex-col bg-white w-full h-screen overflow-hidden justify-start items-center text-secondary">
      <NavBar
        handleLogout={handleOnClickLogout}
        setLoading={setLoading}
        token={token}
        interceptFunc={true}
      />
      <div className="flex flex-row w-full h-full">
        <SideBar active={"contacts"} interceptFunc={true} />
        <div className="flex flex-col w-full">
          <Breadcrumb breads={breads} changeBreadCrumbs={changeBreadCrumbs} />
          <div className="flex flex-col w-full h-full justify-center items-center">
            {Object.keys(contactData).length === 0 ? (
              "Loading..."
            ) : (
              <UpdateContact data_={contactData} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdatedContact;
